import React, { useEffect, useState } from "react";
import "./lab.css"; // Import our unique-named CSS
import {
  FaBars, // Assuming this is for the left hamburger menu
  FaSearch,
  FaChevronDown,
  FaPlus,
  FaRegEdit, // Pencil icon for edit
  FaTimes, // Close icon for modal
  FaDownload, // Assuming the icon next to "Request Lab Work" is download/save
} from "react-icons/fa";
import img from "../../../assets/images/image5.png"; // Import unique-named CSS
import { get } from "../../../utility/fetch2";
import LabReportCard from "./LabReportCard";
import LabReports from "./LabReports";
import moment from "moment/moment";
import { CircularProgress } from "@mui/material";

function LabPatientComponent({ data, dataFromLabProcessed, appointmentId }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [selectedLabRequest, setSelectedLabRequest] = useState(null);
  const [unprocessedLab, setunprocessedLab] = useState([null]);
  const [processedLabWithAppointmentId, setProcessedLabWithAppointmentId] =
    useState([]);
  const [unProcessedLabWithAppointmentId, setUnProcessedLabWithAppointmentId] =
    useState([]);
  // const [unprocessedLab, setunprocessedLab] = useState([null]);
  const [labRequests, setlabRequests] = useState([]);

  useEffect(() => {
    console.log(data);
    appointmentId ? getLabsByAppointmentId() : getLabsUnProcessed();
  }, [data, appointmentId]);

  const onClose = () => {
    setIsModalOpen(!isModalOpen);
  };

  const getLabsUnProcessed = async () => {
    setlabRequests([]);
    setisLoading(true);
    // e.preventDefault();

    try {
      // const response = await get(`/ refertolab/list/${appointmentId}/appointment`);

      // console.log(response);
      // setunprocessedLab(response?.data.recordList);
      // setlabRequests(response?.data.recordList);

      console.log(data);
      console.log(data);

      if (appointmentId) {
        setunprocessedLab(unProcessedLabWithAppointmentId);
        setlabRequests(unProcessedLabWithAppointmentId);
      } else {
        setunprocessedLab(data);
        setlabRequests(data);
      }
      setisLoading(false);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      setisLoading(false);
      // setLabs([]);
    }
  };

  const getLabsByAppointmentId = async () => {
    setlabRequests([]);
    setisLoading(true);
    // e.preventDefault();

    try {
      const response = await get(
        `/refertolab/list/${appointmentId}/appointment`
      );

      console.log(response?.data);

      // First filter by appointmentId, then filter testRequests by status
      const appointmentLabs = Array.isArray(response?.data)
        ? response.data.filter((lab) => lab.appointmentId === appointmentId)
        : [];

      console.log(appointmentLabs);
      // setlabRequests(appointmentLabs);

      // Flatten all testRequests from the filtered appointmentLabs
      // const allTestRequests = appointmentLabs.flatMap(
      //   (lab) => lab.testRequests || []
      // );

      const filteredNotAttended = appointmentLabs.filter(
        (item) => item.status?.toLowerCase() === "not attended"
      );

      const filteredAttended = appointmentLabs.filter(
        (item) => item.status?.toLowerCase() === "attended"
      );

      setUnProcessedLabWithAppointmentId(filteredNotAttended || []);
      setProcessedLabWithAppointmentId(filteredAttended || []);
      // setprocessedLab(filteredNotAttended);
      setlabRequests(filteredNotAttended || []);
      setisLoading(false);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      setisLoading(false);
      // setLabs([]);
    }
  };

  //   method:jime.oauth.token.get
  // timestamp:2025-06-19 13:48:00
  // app_key:8FB345B8693CCD00EAE194100B0FC27D339A22A4105B6558
  // sign:250210fbf644424fbcbcb7c95d06d695
  // sign_method:md5
  // v:1.0
  // format:json
  // userId:Cileasing
  // user_pwd_md5:21218cca77804d2ba1922c33e0151105
  // expires_in:7200

  const getLabsProcessed = async (e) => {
    // e.preventDefault();
    setlabRequests([]);
    setisLoading(true);
    console.log(dataFromLabProcessed);

    try {
      // const response = await get(`/refertolab/list/1/100/processed`);

      // console.log(response);
      if (appointmentId) {
        setunprocessedLab(processedLabWithAppointmentId);
        setlabRequests(processedLabWithAppointmentId);
      } else {
        setunprocessedLab(dataFromLabProcessed);
        setlabRequests(dataFromLabProcessed);
      }

      setisLoading(false);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      setisLoading(false);

      // setLabs([]);
    }
  };

  const openModal = (request) => {
    setSelectedLabRequest(request);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLabRequest(null);
  };

  // Mock data for the lab requests table
  // const labRequests = [
  //   {
  //     id: 1,
  //     patientID: "HS9832",
  //     firstname: "William",
  //     lastname: "Humphrey",
  //     labCentre: "Healing Stripes Hospital, Victoria Island, Lagos",
  //     diagnosis: "Throat-Infection and malaria-infection",
  //     status: "Completed",
  //     dataAdmitted: "12.12.2020",
  //   },
  //   {
  //     id: 2,
  //     patientID: "HS9832",
  //     firstname: "Bolente",
  //     lastname: "Awe",
  //     labCentre: "Reddington Hospitals, Victoria Island, Lagos",
  //     diagnosis: "Child - Delivery",
  //     status: "Completed",
  //     dataAdmitted: "12.12.2020",
  //   },
  //   {
  //     id: 3,
  //     patientID: "HS9832",
  //     firstname: "Victor",
  //     lastname: "Chukwobiobia",
  //     labCentre: "Genesis Specialist Hospital, Lekki 1, Lagos",
  //     diagnosis: "Food-poisoning and chronic headache",
  //     status: "Pending",
  //     dataAdmitted: "12.12.2020",
  //   },
  //   {
  //     id: 4,
  //     patientID: "HS9832",
  //     firstname: "Christopher",
  //     lastname: "Ejike",
  //     labCentre: "St. Nicholas Hospital, Lagos Island",
  //     diagnosis: "Diarrhea and Nausea",
  //     status: "Pending",
  //     dataAdmitted: "12.12.2020",
  //   },
  // ];

  const renderStatusButtons = (dispensed) => {
    const paidStyle = {
      padding: "6px 12px",
      borderRadius: "6px",
      backgroundColor: "#16a34a",
      // : "#dc2626", // green or red
      color: "white",
      border: "none",
      cursor: "pointer",
    };

    const dispensedStyle = {
      padding: "6px 12px",
      borderRadius: "6px",
      backgroundColor: dispensed ? "#2563eb" : "#facc15", // blue or yellow
      color: dispensed ? "white" : "black",
      border: "none",
      cursor: "pointer",
    };

    return (
      <div className="m-b-5" style={{ display: "flex", gap: "8px" }}>
        <button onClick={getLabsProcessed} style={paidStyle}>
          Attended
        </button>
        <button onClick={getLabsUnProcessed} style={dispensedStyle}>
          Unattended
        </button>
      </div>
    );
  };

  return (
    <div className="lab-page__container w-100 ">
      {/* Header Section */}
      <div className="lab-header"></div>

      {/* Tabs Section */}
      <div
        style={{ display: "flex", justifyContent: "space-between" }}
        className="lab-tabs__container"
      >
        <button className="lab-tabs__button lab-tabs__button--active">
          Lab Requests Log
        </button>

        {renderStatusButtons()}
      </div>

      {/* Table Section */}
      <div className="lab-table__wrapper">
        <table className="lab-table">
          <thead className="lab-table__head">
            <tr className="lab-table__row-header">
              <th className="lab-table__header-cell">Date</th>
              <th className="lab-table__header-cell">Time</th>
              <th className="lab-table__header-cell">Firstname</th>
              <th className="lab-table__header-cell">Lastname</th>
              <th className="lab-table__header-cell">Lab Centre</th>
              <th className="lab-table__header-cell">Lab Test</th>
              <th className="lab-table__header-cell">Diagnosis</th>
              <th className="lab-table__header-cell">Status</th>
              {/* <th className="lab-table__header-cell">Data Admitted</th> */}
              <th className="lab-table__header-cell lab-table__header-cell--action"></th>{" "}
              {/* Action column */}
            </tr>
          </thead>
          <tbody className="lab-table__body">
            {labRequests?.length > 0 ? (
              labRequests?.map((request, index) => (
                <tr key={index} className="lab-table__row">
                  <td className="lab-table__cell">
                    <div>
                      <p>{moment(request?.createdAt).format("ll")}</p>
                    </div>
                  </td>
                  <td className="lab-table__cell">
                    <div>
                      <p>{moment(request?.createdAt).format("hh:mm:ss")}</p>
                    </div>
                  </td>
                  <td className="lab-table__cell">
                    {request?.patient.firstName}
                  </td>
                  <td className="lab-table__cell">
                    {request?.patient.lastName}
                  </td>
                  <td className="lab-table__cell lab-table__cell--lab-centre">
                    {request?.labHealthCareProvider.name}
                  </td>
                  <td className="lab-table__cell lab-table__cell--lab-centre">
                    {request?.testRequests?.map((e) => (
                      <li>{e?.referredInternalLabService?.name}</li>
                    ))}
                  </td>
                  {/*  */}
                  <td className="lab-table__cell">{request?.diagnosis}</td>
                  <td className="lab-table__cell">
                    <span
                      className={`lab-table__status lab-table__status--${request?.status
                        .toLowerCase()
                        .replace(" ", "-")}`}
                    >
                      {request?.status}
                    </span>
                  </td>
                  {/* <td className="lab-table__cell">{request?.dataAdmitted}</td> */}
                  <td className="lab-table__cell lab-table__cell--action">
                    {request?.status == "Attended" && (
                      <button
                        className="lab-table__edit-button"
                        onClick={() => openModal(request)}
                      >
                        <FaRegEdit className="lab-table__edit-icon" />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: 20,
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <p>No lab requests found.</p>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="lab-modal__overlay">
          <div
            className=""
            style={{
              maxHeight: "100vh",
              backgroundColor: "white",
              padding: "20px",
              overflow: "hidden",
              overflowY: "auto",
            }}
          >
            <div className="lab-modal__header">
              <h3 className="lab-modal__title">Lab Request Details</h3>
              <button className="lab-modal__close-button" onClick={closeModal}>
                <FaTimes />
              </button>
            </div>

            <div className="lab-modal__body">
              {selectedLabRequest && (
                <>
                  {/* <p className="lab-modal__detail-item">
                    <strong>Patient ID:</strong> {selectedLabRequest.patientID}
                  </p>
                  <p className="lab-modal__detail-item">
                    <strong>Name:</strong> {selectedLabRequest.firstname}{" "}
                    {selectedLabRequest.lastname}
                  </p>
                  <p className="lab-modal__detail-item">
                    <strong>Lab Centre:</strong> {selectedLabRequest.labCentre}
                  </p>
                  <p className="lab-modal__detail-item">
                    <strong>Diagnosis:</strong> {selectedLabRequest.diagnosis}
                  </p>
                  <p className="lab-modal__detail-item">
                    <strong>Status:</strong> {selectedLabRequest.status}
                  </p>
                  <p className="lab-modal__detail-item">
                    <strong>Date Admitted:</strong>{" "}
                    {selectedLabRequest.dataAdmitted}
                  </p> */}
                  <LabReports
                    patientInfo={selectedLabRequest}
                    open={isModalOpen}
                    onClose={onClose}
                  />

                  {/* <LabReportDetails reportData={selectedLabRequest} /> */}

                  {/* Add more details or a form for editing here */}
                </>
              )}
            </div>
            <div className="lab-modal__footer">
              <button
                className="lab-modal__footer-button lab-modal__footer-button--cancel"
                onClick={closeModal}
              >
                Close
              </button>
              {/* <button className="lab-modal__footer-button lab-modal__footer-button--save">Save Changes</button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LabPatientComponent;

// Placeholder images (replace with actual paths if you have them)
// In a real app, you'd import these or get them from props/API
// import xrayImage from './xray.png';   // Assuming you have an xray.png in the same folder
// import heatmapImage from './heatmap.png'; // Assuming you have a heatmap.png in the same folder

function LabReportDetails({ reportData }) {
  const [labReports, setLabreports] = useState([]);

  // Provide default data if props are not supplied or are incomplete
  // const defaultReportData = {
  //   patientName: "Firstname Lastname",
  //   reportDate: "22.12.2023",
  //   reportTime: "10:39am",
  //   subject: "Causative Bacteria Resulting from Respiratory Infection",
  //   labFindingsText: [],
  //   imageUrl1: img,
  //   imageUrl2: img,
  // };

  useEffect(() => {
    // getLabReport();

    console.log(reportData);
  }, [reportData]);

  const getLabReport = async (e) => {
    // e.preventDefault();

    try {
      const response = await get(
        `/patientlabreport/internal-lab-report/lab-request/${reportData.id}`
      );

      console.log(
        response?.data[0]?.patientTestReports[0]?.labTestServiceResults.length >
          0
          ? response?.data[0]?.patientTestReports[0]?.labTestServiceResults[0]
              ?.testDetails
          : {}
      );

      setLabreports(
        response?.data[0]?.patientTestReports[0]?.labTestServiceResults.length >
          0
          ? response?.data[0]?.patientTestReports[0]?.labTestServiceResults[0]
              ?.testDetails
          : {}
      );
      // setunprocessedLab(response?.data.recordList);
      // setlabRequests(response?.data.recordList);
    } catch (error) {
      console.error("Error fetching laboratories:", error);
      // setLabs([]);
    }
  };

  // console.log(reportData);

  const data = { ...reportData }; // Merge provided data with defaults

  return (
    <div className="lr-report-container" style={{ width: "900px" }}>
      {/* hiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii */}

      {/* Header Section */}
      <div className="lr-header-section">
        <div className="lr-header-section__left">
          <span className="lr-header-section__patient-name">
            {`${reportData?.patient.firstName} ${reportData?.patient.lastName} `}
          </span>
          <span className="lr-header-section__report-label">Lab Report</span>
        </div>
        {/* <div className="lr-header-section__right">
          <span className="lr-header-section__date">
            {reportData?.createdAt}
          </span>
          <span className="lr-header-section__time">
            {reportData?.createdAt}
          </span>
        </div> */}
      </div>

      {/* Subject Section */}
      <div className="lr-subject-section">
        <span className="lr-subject-section__label">Subject</span>
        <span className="lr-subject-section__text">
          {reportData?.diagnosis}
        </span>
      </div>

      {/* Lab Findings Section */}
      <div className="lr-findings-section">
        {/* <h3 className="lr-findings-section__title">Lab Findings</h3> */}
        <div className="lr-findings-section__text-content">
          {reportData?.labFindingsText?.map((paragraph, index) => (
            <p key={index} className="lr-findings-section__paragraph">
              {paragraph}
            </p>
          ))}
        </div>
        {/* <LabReportCard details={labReports} /> */}
      </div>

      {/* Image Section */}
      <div className="lr-images-section">
        {reportData?.imageUrl1 && (
          <div className="lr-images-section__image-wrapper">
            <img
              src={reportData?.imageUrl1}
              alt="Lab Finding 1"
              className="lr-images-section__image"
            />
          </div>
        )}
        {reportData?.imageUrl2 && (
          <div className="lr-images-section__image-wrapper">
            <img
              src={reportData?.imageUrl2}
              alt="Lab Finding 2"
              className="lr-images-section__image"
            />
          </div>
        )}
      </div>
    </div>
  );
}
